import React, { useEffect, useRef } from 'react';
import { css } from 'emotion';
var ShoppingOrder = function ShoppingOrder(_ref) {
  var _ref$question$custom = _ref.question.custom;
  _ref$question$custom = _ref$question$custom === void 0 ? {} : _ref$question$custom;
  var _ref$question$custom$ = _ref$question$custom.title,
    title = _ref$question$custom$ === void 0 ? '盐津铺子/小银线鱼130g（约8包）' : _ref$question$custom$,
    _ref$question$custom$2 = _ref$question$custom.img,
    imgSrc = _ref$question$custom$2 === void 0 ? '' : _ref$question$custom$2,
    _ref$question$custom$3 = _ref$question$custom.ctime,
    ctime = _ref$question$custom$3 === void 0 ? 1629177344 : _ref$question$custom$3,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var date = new Date(ctime * 1000);
  var m = date.getMonth() + 1;
  var d = date.getDate();
  var imgRef = useRef(null);
  var changeSize = function changeSize(img) {
    var width = img.naturalWidth;
    var height = img.naturalHeight;
    var maxW = Math.min(height, isMobile ? 80 : 100);
    if (maxW !== width) {
      img.setAttribute('style', "width: ".concat(maxW, "px !important; height: ").concat(maxW * height / width, "px !important;"));
    }
  };
  useEffect(function () {
    if (imgRef.current && imgSrc) {
      var img = imgRef.current;
      img.onload = function () {
        return changeSize(img);
      };
    }
  }, [imgRef.current]);
  return React.createElement("div", {
    className: descriptionWrapper(isMobile)
  }, React.createElement("p", null, "\u8BA2\u5355\u4FE1\u606F"), React.createElement("div", {
    className: "flex"
  }, imgSrc && React.createElement("img", {
    src: imgSrc,
    alt: "order-pic",
    ref: imgRef
  }), React.createElement("div", null, React.createElement("b", null, title), React.createElement("p", {
    style: {
      marginTop: 5
    }
  }, "\u4E0B\u5355\u65E5\u671F:", ' ', "".concat(date.getFullYear(), "-").concat(Math.floor(m / 10)).concat(m % 10, "-").concat(Math.floor(d / 10)).concat(d % 10)))));
};
var _ref2 = "background:";
var _ref3 = ";color:var(--text-color-secondary);font-weight:400;font-size:1rem;font-size:14px;padding:";
var _ref4 = ";p:first-of-type{margin-bottom:10px;font-weight:500;color:var(--text-color-thirdly);}img{margin-right:";
var _ref5 = "px;}";
var descriptionWrapper = function descriptionWrapper(isMobile) {
  return /*#__PURE__*/css(_ref2, isMobile ? 'var(--am-entity-bg)' : 'var(--question-bg)', _ref3, isMobile ? '9px' : '15px 42px 20px 36px', _ref4, isMobile ? 20 : 50, _ref5);
};
export default ShoppingOrder;